import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../components/Layout'
import SEO from "../components/seo"
import BookingForm from "../components/BookingForm"
import RoomsList from '../components/RoomsList'
import PageBanner from '../components/PageBanner'
import banner_image from '../images/page-banners/suites.jpg'
import MainFacilities from '../components/MainFacilities';
import ChildrenNotes from '../components/ChildrenNotes';

const suitesPage =({data}) => {

  const {suites} = data

  return (

    <Layout sidebarComponent={<BookingForm colWidth="col-md-12" productType="Luxury suite"/>}>
      
      <SEO title="Our Luxury suites" />

      <PageBanner image={banner_image} title="Our Luxury suites"/>

      <MainFacilities />

      <div className="inner-content">
        <div className="row">
          <div className="col-lg-12">
            <RoomsList rooms={suites.edges}/>
          </div>
          <div className="col-lg-12">
            <ChildrenNotes />
          </div>
        </div>
      </div>

    </Layout>
    
  )
}

export default suitesPage

export const suitesPageQuery = graphql`
  query suitesPageQuery {
    suites:
      allMarkdownRemark (
        filter: {
          frontmatter: {type: {eq: "Luxury suite"}}
        }
        sort: { order: DESC, fields: [frontmatter___date]}
      ) {
        edges {
          node {
            id
            frontmatter {
              title
              slogan
              type
              excerpt
              price
              path
              images {
                childImageSharp {
                  fluid(quality: 100, maxWidth: 750) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      }
  }
`